import React, { useEffect, useRef } from 'react';
import { get } from 'lodash';
import { PRODUCT_URL_PREFIX, PRODUCTS, trackEvent } from '@pulse/nav';
import useDefaultApp from './hooks/useDefaultApp';
import useUser, { isCustomerService, isDeveloper } from './hooks/useUser';
import { StyledLoader } from './styled';
import { Image, Spin } from 'antd';
import Logo from '@images/conviva.png';
import { LOGIN_SUCCESS, LOGIN_END } from '@utils/sensor/track';

const redirectToPage = (url) => {
  console.log('redirect to', url);
  window.location.replace(url);
};

const LOGIN_PENDING_KEY = 'login_pending';
const LOGIN_STALENESS_MS = 15 * 60 * 1000;

const useRouteUser = () => {
  const { loading: defaultAppLoading, data: defaultApp } = useDefaultApp();
  const { loading: userLoading, data: user } = useUser();
  const loginTrackedRef = useRef(false);

  const landing = get(defaultApp, 'landing', null);
  const product = get(defaultApp, 'app', null);

  useEffect(() => {
    if (!userLoading && user && !loginTrackedRef.current) {
      loginTrackedRef.current = true;
      try {
        const raw = sessionStorage.getItem(LOGIN_PENDING_KEY);
        if (raw) {
          sessionStorage.removeItem(LOGIN_PENDING_KEY);
          const { email, timestamp } = JSON.parse(raw);
          const duration = Date.now() - timestamp;
          if (duration < LOGIN_STALENESS_MS) {
            trackEvent({
              name: LOGIN_SUCCESS,
              data: { useremail: email, duration },
            });
            trackEvent({
              name: LOGIN_END,
              data: { useremail: email, duration },
            });
          }
        }
      } catch {
        /* ignore malformed data */
      }
    }
  }, [userLoading, user]);

  if (!userLoading) {
    if (isCustomerService(user)) {
      redirectToPage('/app/experience-insights/dashboard/viewer-module');
      return;
    }

    if (isDeveloper(user)) {
      redirectToPage('/app/settings/personal_info');
      return;
    }
  }

  if (!userLoading && !defaultAppLoading) {
    // Jump to default landing page
    if (landing?.path) {
      const { path } = landing;
      if (/^\/app\/?/.test(path)) {
        redirectToPage(path);
      } else {
        redirectToPage(`/app${path}`);
      }
      return;
    }

    if (defaultApp) {
      switch (defaultApp.app) {
        case 'ei':
          redirectToPage(`${PRODUCT_URL_PREFIX[PRODUCTS.EI]}/dashboard/trends`);
          break;
        case 'ai':
          redirectToPage(`${PRODUCT_URL_PREFIX[PRODUCTS.AI]}/dashboard/trends`);
          break;
        case 'app':
          redirectToPage(`${PRODUCT_URL_PREFIX[PRODUCTS.APP]}/dashboard/overview`);
          break;
        case 'precision':
          redirectToPage('/app/precision/precision_policy');
          break;
        case 'p4':
          redirectToPage(`${PRODUCT_URL_PREFIX[PRODUCTS.EI]}/dashboard/trends`);
          break;
        case 'vi': {
          redirectToPage(PRODUCT_URL_PREFIX.VI);
          break;
        }
        case 'si': {
          redirectToPage(PRODUCT_URL_PREFIX.SI);
          break;
        }
        case 'ci': {
          redirectToPage(PRODUCT_URL_PREFIX.CI);
          break;
        }
        case 'advi': {
          redirectToPage(PRODUCT_URL_PREFIX.ADVI);
          break;
        }
        default:
          redirectToPage(`${PRODUCT_URL_PREFIX[PRODUCTS.EI]}/dashboard/trends`);
      }
      return;
    }
  }
};

const RouteUser = () => {
  useRouteUser();
  return (
    <StyledLoader>
      <Image src={Logo} preview={false} />
      <Spin />
      <div>Loading Profile...</div>
    </StyledLoader>
  );
};

export default RouteUser;
